// TODO deprecated
import { FC } from 'react';
import { Drawer } from 'antd';

import { Button } from '@/shared/components';
import { Row } from '@/shared/components/layout';
import { useModalsStore } from '@/widgets/modals';

import { SelectAttachToModalProps } from '../../types';

type AssignOption = {
  key: string;
  title: string;
  whereToAttachOptions?: string[];
  link: string;
};

const AssignDocumentOptions: AssignOption[] = [
  {
    key: 'private_document',
    title: 'Create personal document',
    whereToAttachOptions: ['Asset', 'Next Owner', 'My profile'],
    link: ``,
  },
  {
    key: 'personal_identifier',
    title: 'Create personal identifier',
    whereToAttachOptions: ['Next Owner', 'My profile'],
    // link: `/personal-identifiers/create?file=${query.file}`,
    link: `/personal-identifiers/create`,
  },
  {
    key: 'add_to_existing_private_document',
    title: 'Add to existing personal document',
    // link: `/documents/inbox/attach/private-document?file=${query.file}`,
    link: `/documents/inbox/attach/private-document`,
  },
  {
    key: 'add_to_existing_personal_identifier',
    title: 'Add to existing personal identifier',
    whereToAttachOptions: ['My Personal identifiers', 'Next Owner personal identifiers'],
    // link: `/documents/inbox/attach/personal-identifier?file=${query.file}`,
    link: `/documents/inbox/attach/personal-identifier`,
  },
];

export const SelectAttachToModal: FC<SelectAttachToModalProps> = ({ onSelect }) => {
  const modals = useModalsStore();

  const onClick = (option: AssignOption) => {
    if (option.key === 'private_document') {
      modals.openModal({
        type: 'SelectPrivateDocumentCategoryModal',
      });
    } else if (option.link) {
      // TODO WA-3065 set files
      onSelect(option.link);
    }
  };

  return (
    <Drawer
      onClose={() => modals.closeModal()}
      placement="bottom"
      height={320}
      closeIcon={null}
      title="Choose where to attach document"
      open
    >
      <Row direction="column" justifyContent="space-between" gap={8}>
        {AssignDocumentOptions.map((item, idx) => (
          <>
            <Button key={idx} text={item.title} onClick={() => onClick(item)} />
            {/* <ChooseList
              title="Choose where to attach document"
              open={whereToAttachOpen}
              data={whereToAttachData}
              onClose={() => setWhereToAttachOpen(false)}
              onClick={onSelect}
            /> */}
          </>
        ))}
      </Row>
    </Drawer>
  );
};
